import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { Form, TextArea } from 'semantic-ui-react'
import CheckAdminUserId from '../../others/CheckAdminUserId';
import $ from "jquery";
import Loading from '../../loading';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';

class EditEmployeeDetails extends React.Component {

  state = {
    dialog: false, roles: []
  }

  getRoles(type) {
    let context = this;
    $.ajax({
      type: 'POST', url: Server() + 'EmployeeDetails/roles.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          if (type == 'edit') {
            context.openEdit(data);
          }
          else {
            context.setState({ roles: data, dialog: true })
          }
        } catch (e) {
          alert('Error!!!');
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }


  openEdit(roles) {
    let data = this.props.data;
    this.setState({ roles, address: data.address, role: data.role, pincode: data.pincode, dob: data.dob, gender: data.gender, dialog: true, name: data.name, mobile: data.mobile, alt_mobile: data.alt_mobile, mailid: data.mailid, device_id: data.device_id, status: data.status, id: data.id })
  }


  submit() {
    if (this.props.type == 'add') {
      this.add();
      return;
    }
    let context = this;
    let { name, mobile, alt_mobile, mailid, device_id, status, id, address, pincode, dob, role, gender } = this.state;
    let data = { name, mobile, alt_mobile, mailid, device_id, status, id, address, pincode, dob, role, gender };
    this.setState({ load: false })
    $.ajax({ type: 'POST', data: data,
      url: Server() + 'EmployeeDetails/edit.php',
      success: function(data) {
        if (data == 1) {
          let employeeDetails =  context.props.employeeDetails;
          employeeDetails.map((c) => {
            if (c.id == id) {
              c.name = name;
              c.mobile = mobile;
              c.alt_mobile = alt_mobile;
              c.mailid = mailid;
              c.device_id = device_id;
              c.status = status;
            }
          })
          context.setState({ dialog: false })
          context.props.updateData(employeeDetails);
        }
      },
      error: function(err) {
        context.setState({ load: false, });
      }
    })
  }

  add() {
    let context = this;
    let { name, mobile, alt_mobile, mailid, device_id, status, address, pincode, dob, role, gender } = this.state;
    let data = { name, mobile, alt_mobile, mailid, device_id, status, address, pincode, dob, role, gender };
    context.setState({ load: true, message: 'Adding Employee' });
    $.ajax({ type: 'POST', data,
      url: Server() + 'EmployeeDetails/add.php',
      success: function(data) {
        if (data == 1) {
          context.props.getEmployeeDetails();
          context.setState({  name: '', mobile: '', alt_mobile: '', mailid: '', device_id: '', status: '', 
                              address: '', pincode: '', dob: '', role: '', gender: '', dialog: false, load: false })
        }
        else {
          alert('Error')
          context.setState({ dialog: false, load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false, });
      }
    })
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value, }); }


  changeStatus() {
    let status = this.state.status;
    if (status == 'Active') {
      this.setState({ status: 'Inactive' })
    }
    else {
      this.setState({ status: 'Active' })
    }
  }


  changeStatus1() {
    let role = this.state.role;
    if (role == 'User') {
      this.setState({ role: 'Admin' })
    }
    else {
      this.setState({ role: 'User' })
    }
  }

  changeStatus2() {
    let gender = this.state.gender;
    if (gender == 'Male') {
      this.setState({ gender: 'Female' })
    }
    else {
      this.setState({ gender: 'Male' })
    }
  }


  resetPassword(id) {
    let context = this;
    context.setState({ load: true, message: 'Reset Password', })
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'EmployeeDetails/resetpassword.php',
      success: function (data) {
        context.setState({ load: false, });
        if (data == 1) {
          alert('Password Reset Success!!!')
        }
        else {
          alert('Failed')
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  onChange = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  resetCrmDeviceId(id) {
    let context = this;
    context.setState({ load: true, message: 'Reset Password', })
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'EmployeeDetails/ResetCRMDeviceId.php',
      success: function (data) {
        context.setState({ load: false, });
        if (data == 1) {
          alert('Device Id Reseted!!!')
        }
        else {
          alert('Failed')
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let cook = (ReadCookie("vaigai"));
    let eid = cook.id;
    const { fullScreen } = this.props;
    let { id, name, mobile, alt_mobile, mailid, device_id, status, load, message, pincode, dob, role, address, gender } = this.state;
    return (
      <div>
        {
          this.props.type == 'edit' ?
          (
            <u style={{color: 'blue', cursor: 'pointer'}} onClick={this.getRoles.bind(this, 'edit')}>Edit</u>
          ):
          (
            <div><Button onClick={this.getRoles.bind(this, 'add')}>Add</Button><br/><br/></div>
          )
        }
        <Loading load={load} message={message} />
        <Dialog fullScreen={fullScreen} onClose={ () => { this.setState({ dialog: false }) }} open={this.state.dialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 200}}> {"Edit Details"} </DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="Name" label="Name" value={name} onChange={this.handleChange('name')} />
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="mobile" label="Mobile" value={mobile} onChange={this.handleChange('mobile')} />
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="Ait.Mobile" label="Ait.Mobile" value={alt_mobile} onChange={this.handleChange('alt_mobile')} />
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="MailId" label="MailId" value={mailid} onChange={this.handleChange('mailid')} />
              </Grid>

              <Grid item xs={12} style={{marginTop: 20}}>
                Address<br/>
                <Form>
                  <TextArea value={address} onChange={this.onChange('address')} placeholder='Address' />
                </Form>
              </Grid>


              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="Pincode" label="Pincode" value={pincode} onChange={this.handleChange('pincode')} />
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField type="date" placeholder="DOB" label="DOB" value={dob} onChange={this.handleChange('dob')} />
              </Grid>




              <Grid item xs={6} style={{marginTop: 20}}>
                Status<br/>
                <FormControl style={{width: '68%'}}>
                  <Select labelId="demo-simple-select-label"
                    id="demo-simple-select" value={status} onChange={this.changeStatus.bind(this)}>
                    <MenuItem value={'Active'}>Active</MenuItem>
                    <MenuItem value={'Inactive'}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <TextField placeholder="Device Id" label="Device Id" value={device_id} onChange={this.handleChange('device_id')} />
              </Grid>


              <Grid item xs={6} style={{marginTop: 20, display: 'none'}}>
                Role<br/>
                <FormControl style={{width: '68%'}}>
                  <Select labelId="demo-simple-select-label"
                    id="demo-simple-select" value={role} onChange={this.changeStatus1.bind(this)}>
                      { 
                        this.state.roles.map((cc) => {
                          return (<MenuItem value={cc.role}>{cc.role}</MenuItem>)
                        }) 
                      }
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} style={{marginTop: 20}}>
                Gender<br/>
                <FormControl style={{width: '68%'}}>
                  <Select labelId="demo-simple-select-label"
                    id="demo-simple-select" value={gender} onChange={this.changeStatus2.bind(this)}>
                    <MenuItem value={'Male'}>Male</MenuItem>
                    <MenuItem value={'Female'}>Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{marginTop: 20}}>
                <br/>
                {eid == 1 || eid == 13 || eid == 6 ?
                  <Button color="secondary" onClick={this.resetPassword.bind(this, id)}>Reset Password</Button>: ''
                }
              </Grid>

              <Grid item xs={6} style={{marginTop: 20}}>
                { 
                  CheckAdminUserId(eid) ? 
                  <Button color="secondary" onClick={this.resetCrmDeviceId.bind(this, id)}>Reset CRM Device ID</Button>:
                  null
                }
              </Grid>

            </Grid>
            
            
          </DialogContent>
          <DialogActions>
            <Button primary onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
            <Button primary onClick={this.submit.bind(this, 'save')}>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default EditEmployeeDetails;
